import PropTypes from 'prop-types';

import { Accordion } from '../accordion';
import { Box, Flex } from '../grid';
import { Divider } from '../divider';
import { Label, P, Subheading } from '../typography';

const OrderSummary = ({ price, quantity }) => {
  const formattedPrice = `$${price}`;

  const quantityBox = (
    <Flex
      alignItems="center"
      borderColor="grey300"
      borderStyle="solid"
      borderWidth="1px"
      height="1.5rem"
      justifyContent="center"
      mr="0.5rem"
      minWidth="1.5rem"
    >
      <P variant={3}>{quantity}</P>
    </Flex>
  );

  const hasSelectedItem = price > 0;

  const orderSummaryContent = (
    <Flex
      flexDirection="column"
      backgroundColor="white"
      width="100%"
      py={{ xs: 0, md: 1 }}
      px={{ xs: 0, md: '1.5rem' }}
    >
      <Flex flexDirection="column">
        <Subheading variant={3} mb={1} display={{ xs: 'none', md: 'inherit' }}>
          Your items
        </Subheading>

        {hasSelectedItem && (
          <Flex mb={1} justifyContent="space-between" alignItems="center">
            <Flex alignItems="center">
              {quantityBox}
              <Label>Gift Card</Label>
            </Flex>
            <P variant={4}>{formattedPrice}</P>
          </Flex>
        )}
      </Flex>

      <Divider mb={1} />
      <Flex justifyContent="space-between" alignItems="center">
        <P variant={3}>Total</P>
        <P variant={3}>{formattedPrice}</P>
      </Flex>
    </Flex>
  );

  return (
    <>
      <Box bg="white" width="100%" p={1} display={{ xs: 'inherit', md: 'none' }}>
        <Accordion title="Your items">{orderSummaryContent}</Accordion>
      </Box>
      <Box display={{ xs: 'none', md: 'inherit' }}>{orderSummaryContent}</Box>
    </>
  );
};

OrderSummary.propTypes = {
  price: PropTypes.string.isRequired,
  quantity: PropTypes.string.isRequired,
};

export { OrderSummary };
